var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page ls-container",class:{ 'pt-4': _vm.$vuetify.breakpoint.lgAndUp }},[_c('Banner',{attrs:{"isHome":""}}),_c('CollectionFeed'),_c('AppFeed')],1)}
var staticRenderFns = []

export { render, staticRenderFns }